export default __webpack_public_path__ + "static/media/mmlogo.b2cd141c.png";